"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordResetMessage = void 0;
const base_html_1 = require("./base-html");
class PasswordResetMessage {
    constructor(account, url) {
        this.account = account;
        this.url = url;
        this.title = "Neues Passwort Wählen";
    }
    get recipient() {
        return this.account.email || "";
    }
    get text() {
        return `
Hallo ${this.account.name},

Bitte benutze folgenden Link um dein Passwort zurück zu setzen:

${this.url}

Mit freundlichen Grüßen,
Dein Pentacode Team
`;
    }
    get html() {
        return (0, base_html_1.base)(`
            ${(0, base_html_1.paragraph)(`Hallo ${this.account.name},`)}

            ${(0, base_html_1.paragraph)(`Bitte benutze folgenden Link um ein neues Passwort zu wählen:`)}

            ${(0, base_html_1.button)("Neues Passwort Wählen", this.url)}

            ${(0, base_html_1.paragraph)(`
                Mit freundlichen Grüßen,<br>
                Dein Pentacode Team
            `)}
        `);
    }
}
exports.PasswordResetMessage = PasswordResetMessage;
//# sourceMappingURL=password-reset.js.map